import {
  ComingSoonTag,
  PopoverListButtonItem,
} from '@aibees/shared/components';
import { SHARED_ROUTES as R } from '@aibees/shared/constants';
import { isFeatureEnabled } from '@aibees/shared/feature-flags';
import { FEATURE_FLAGS } from '@aibees/shared/feature-flags/constants';
import { FeatureFlags } from '@aibees/shared/feature-flags/types';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { TeamMemberActionType as ActionType } from './types';

export const ITEMS: Record<ActionType, PopoverListButtonItem> = {
  deactivate: {
    key: ActionType.deactivate,
    label: <Typography variant="body4">Deactivate</Typography>,
  },
  editRole: {
    key: ActionType.editRole,
    label: <Typography variant="body4">Edit Role</Typography>,
  },
  activate: {
    key: ActionType.activate,
    label: <Typography variant="body4">Activate</Typography>,
  },
  creditCap: {
    key: ActionType.creditCap,
    disabled: true,
    label: (
      <Typography variant="body4">
        Add Credit Cap <ComingSoonTag size="small" />
      </Typography>
    ),
  },
  creditUsage: {
    key: ActionType.creditUsage,
    label: (
      <Typography variant="body4">
        <Link
          to={R.creditUsage}
          style={{ textDecoration: 'none', color: '#344054' }}
        >
          View Credit Usage
        </Link>
      </Typography>
    ),
  },

  delete: {
    key: ActionType.delete,
    label: <Typography variant="body4">Delete</Typography>,
  },
  reactivate: {
    key: ActionType.reactivate,
    label: <Typography variant="body4">Reactivate</Typography>,
  },
  resend: {
    key: ActionType.resend,
    label: <Typography variant="body4">Resend</Typography>,
    disabled: !isFeatureEnabled(
      FEATURE_FLAGS,
      FeatureFlags.RESEND_INVITATION_EMAIL
    ),
  },
  changeOwnership: {
    key: ActionType.changeOwnership,
    label: <Typography variant="body4">Change Ownership</Typography>,
  },
  cancelInvite: {
    key: ActionType.cancelInvite,
    label: <Typography variant="body4">Cancel Invite</Typography>,
  },
  cancelTransfer: {
    key: ActionType.cancelTransfer,
    label: <Typography variant="body4">Cancel Transfer</Typography>,
  },
};
